<template>
  <div class="cell" :class="{'divide-line': divide}" @click="$emit('click')">
    <div class="left" :style="{color: leftColor}">{{ leftText }}</div>
    <div class="right"  >
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    leftText: {
      type: String,
      required: true
    },
    leftColor: {
      type: String,
      default: '#363636'
    },
    divide: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '../css/var'

.divide-line
  border-bottom 1px solid $divide-line-color

.cell
  height pt(95)
  display flex
  justify-content flex-start
  align-items center
  width 100%
  font-size $normal-font-size
  .left
    width 4em
    flex 0 1 auto
    text-align left
    single-line()
  .right
    flex 1 1 auto
    text-align right
    margin-right pt(20)
</style>




// WEBPACK FOOTER //
// item-custom-right.vue?f9245fe4